import { WsSelect, WsSelectObj } from 'wisestep-base';

import { WsAccordion } from '../../components';
import WsFilterProps from '../../models/WsFilterProps';

export const options: WsSelectObj[] = [
  {
    label: 'Not Available',
    value: 'NotAvailable',
  },
  {
    label: 'Available Immediately',
    value: 'AvailableImmediately',
  },
  {
    label: 'Available In 15 Days',
    value: 'AvailableIn15Days',
  },
  {
    label: 'Available In 30 Days',
    value: 'AvailableIn30Days',
  },
];

const AvailabilityFilter = ({ name, title = 'Availability' }: WsFilterProps) => (
  <WsAccordion title={title}>
    <WsSelect name={name} selectArray={options} placeholder="Select" />
  </WsAccordion>
);
export default AvailabilityFilter;
